<template>
  <div class="g-footer" @click="toBan">
    ©2020 bpmchisel.Com All Rights Reserved!京ICP备2021001688号-2
  </div>
</template>
<script>
export default {
  data () {
    return {
      fileBaseUrl: this.$baseUrl,
      downloadVisible: false,
      chatVisible: false,
      companyVisible: false,
      companyInfo: {},
      downloads: [],
      questions: [],
      linkObj: undefined
    }
  },
  created () {
    this.getCompanyInfo()
  },
  methods: {
    getCompanyInfo () {
      this.$aboutUs.companyInfo().then(res => {
        if (!res.data) {
          this.$message.warn(this.$t('common.noData'))
          return
        }
        this.companyObj = this.$json2object(res.data)
        const { bizCompanyAbout = {} } = this.companyObj
        this.companyInfo = bizCompanyAbout
        this.downloads = JSON.parse(bizCompanyAbout.download)
        this.questions = JSON.parse(bizCompanyAbout.questions)
        this.linkObj = JSON.parse(bizCompanyAbout.links || '[]')[0]
      })
    },

    go2other (url) {
      window.open(url, '_blank')
    },

    go2aboutUs () {
      this.$router.push({ name: 'AboutUs' })
    },

    toBan () {
      window.location.href = 'https://beian.miit.gov.cn'
    }
  }
}
</script>
<style lang="less" scoped>
.g-footer {
  background:#376E25;
  padding: 10px 0;
  text-align: center;
  color: #FFFFFF;
  font-size: 9px;
  a{
    color: #FFFFFF;
    text-decoration: none;
    background-color: transparent;
  }
  a:hover{
    text-decoration: underline;
  }
}
</style>
